import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ActiveCampaignComponent } from './active-campaign/active-campaign.component';
import { AweberComponent } from './aweber/aweber.component';
import { ConstantContactComponent } from './constant-contact/constant-contact.component';
import { DripComponent } from './drip/drip.component';
import { GetResponseComponent } from './get-response/get-response.component';
import { GooglesheetsComponent } from './googlesheets/googlesheets.component';
import { HubspotComponent } from './hubspot/hubspot.component';
import { IcontactComponent } from './icontact/icontact.component';
import { InfusionSoftComponent } from './infusion-soft/infusion-soft.component';
import { IntegrationComponent } from './integration.component';
import { KlaviyoComponent } from './klaviyo/klaviyo.component';
import { MailchimpComponent } from './mailchimp/mailchimp.component';
import { MailgunComponent } from './mailgun/mailgun.component';
import { MarketoComponent } from './marketo/marketo.component';
import { ZapierComponent } from './zapier/zapier.component';
import { ZohoComponent } from './zoho/zoho.component';
import { SendinblueComponent } from './sendinblue/sendinblue.component';
import { ConvertkitComponent } from './convertkit/convertkit.component';
import { LemlistComponent } from './lemlist/lemlist.component';
import { MoosendComponent } from './moosend/moosend.component';
import { MailerliteComponent } from './mailerlite/mailerlite.component';
import { AutokloseComponent } from './autoklose/autoklose.component';
import { Clay } from './clay/clay';
import { Apollo } from './apollo/apollo';
export const routes: Routes = [
  {
    path: '', children: [
      {
        path: '', component: IntegrationComponent,
        data: {
          title: 'Connect KudosHub with Clay, Apollo, HubSpot, Zapier & More',
          description: 'Explore KudosHub integrations for CRMs, ESPs, and APIs. Connect, sync, and validate emails with 99% accuracy while automating workflows in minutes.',
          keywords: '',
          ogTitle: 'Connect KudosHub with Clay, Apollo, HubSpot, Zapier & More',
          ogDesc: 'Explore KudosHub integrations for CRMs, ESPs, and APIs. Connect, sync, and validate emails with 99% accuracy while automating workflows in minutes.',
          ogImage: 'https://www.kudoshub.com/theme/images/og-images/integrations.webp',
          ogUrl: 'https://www.kudoshub.com/integrations',
          twitterTitle: 'Connect KudosHub with Clay, Apollo, HubSpot, Zapier & More',
          twitterDesc: 'Explore KudosHub integrations for CRMs, ESPs, and APIs. Connect, sync, and validate emails with 99% accuracy while automating workflows in minutes.',
          twitterImage: 'https://www.kudoshub.com/theme/images/og-images/integrations.webp',
          dateModified: '2025-11-07T11:30:00+05:30'
        }
      },
      // {
      //   path: 'mailchimp',
      //   component: MailchimpComponent,
      //   data: {
      //     title: "Mailchimp",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'Mailchimp',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/mailchimp',
      //     twitterTitle: 'Mailchimp',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'

      //   }
      // },
      {
        path: 'hubspot',
        component: HubspotComponent,
        data: {
          title: "Hubspot",
          description: '',
          keywords: '',
          ogTitle: 'Hubspot',
          ogDesc: '',
          ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
          ogUrl: 'https://www.kudoshub.com/integrations/hubspot',
          twitterTitle: 'Hubspot',
          twitterDesc: '',
          twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
        }
      },
      // {
      //   path: 'aweber',
      //   component: AweberComponent,
      //   data: {
      //     title: "Aweber",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'Aweber',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/aweber',
      //     twitterTitle: 'Aweber',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'drip',
      //   component: DripComponent,
      //   data: {
      //     title: "Drip",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'Drip',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/drip',
      //     twitterTitle: 'Drip',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'klaviyo',
      //   component: KlaviyoComponent,
      //   data: {
      //     title: "Klaviyo",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'Klaviyo',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/klaviyo',
      //     twitterTitle: 'Klaviyo',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'zapier',
      //   component: ZapierComponent,
      //   data: {
      //     title: "Zapier",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'Zapier',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/zapier',
      //     twitterTitle: 'Zapier',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'icontact',
      //   component: IcontactComponent,
      //   data: {
      //     title: "iCONTACT",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'iCONTACT',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/icontact',
      //     twitterTitle: 'iCONTACT',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'constant-contact',
      //   component: ConstantContactComponent,
      //   data: {
      //     title: "ConstantContact",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'ConstantContact',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/constant-contact',
      //     twitterTitle: 'ConstantContact',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'mailgun',
      //   component: MailgunComponent,
      //   data: {
      //     title: "MailGun",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'MailGun',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/mailgun',
      //     twitterTitle: 'MailGun',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'keap',
      //   component: InfusionSoftComponent,
      //   data: {
      //     title: "Keap",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'Keap',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/keap',
      //     twitterTitle: 'Keap',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'zoho',
      //   component: ZohoComponent,
      //   data: {
      //     title: "Zoho",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'Zoho',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/zoho',
      //     twitterTitle: 'Zoho',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'get-response',
      //   component: GetResponseComponent,
      //   data: {
      //     title: "GetResponse",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'GetResponse',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/get-response',
      //     twitterTitle: 'GetResponse',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'marketo',
      //   component: MarketoComponent,
      //   data: {
      //     title: "Marketo",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'Marketo',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/marketo',
      //     twitterTitle: 'Marketo',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'googlesheets',
      //   component: GooglesheetsComponent,
      //   data: {
      //     title: "GoogleSheet",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'GoogleSheet',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/googlesheets',
      //     twitterTitle: 'GoogleSheet',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'active-campaign',
      //   component: ActiveCampaignComponent,
      //   data: {
      //     title: "ActiveCampaign",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'ActiveCampaign',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/active-campaign',
      //     twitterTitle: 'ActiveCampaign',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'brevo',
      //   component: SendinblueComponent,
      //   data: {
      //     title: "Brevo",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'Brevo',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/brevo',
      //     twitterTitle: 'Brevo',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'kit',
      //   component: ConvertkitComponent,
      //   data: {
      //     title: "Kit",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'Kit',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/kit',
      //     twitterTitle: 'Kit',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'lemlist',
      //   component: LemlistComponent,
      //   data: {
      //     title: "Lemlist",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'Lemlist',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/lemlist',
      //     twitterTitle: 'Lemlist',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'moosend',
      //   component: MoosendComponent,
      //   data: {
      //     title: "Moosend",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'Moosend',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/moosend',
      //     twitterTitle: 'Moosend',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'mailerlite',
      //   component: MailerliteComponent,
      //   data: {
      //     title: "Mailerlite",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'Mailerlite',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/mailerlite',
      //     twitterTitle: 'Mailerlite',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      // {
      //   path: 'autoklose',
      //   component: AutokloseComponent,
      //   data: {
      //     title: "Autoklose",
      //     description: '',
      //     keywords: '',
      //     ogTitle: 'Autoklose',
      //     ogDesc: '',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/autoklose',
      //     twitterTitle: 'Autoklose',
      //     twitterDesc: '',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp'
      //   }
      // },
      {
        path: 'clay',
        component: Clay,
        data: {
          title: "Connect KudosHub with Clay.com to Automate Email Validation",
          description: 'Automate real-time email validation inside Clay.com with KudosHub. Score emails, eliminate bounces, and improve deliverability to maintain lead quality.',
          keywords: '',
          ogTitle: 'Connect KudosHub with Clay.com to Automate Email Validation',
          ogDesc: 'Automate real-time email validation inside Clay.com with KudosHub. Score emails, eliminate bounces, and improve deliverability to maintain lead quality.',
          ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
          ogUrl: 'https://www.kudoshub.com/integrations/clay',
          twitterTitle: 'Connect KudosHub with Clay.com to Automate Email Validation',
          twitterDesc: 'Automate real-time email validation inside Clay.com with KudosHub. Score emails, eliminate bounces, and improve deliverability to maintain lead quality.',
          twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
          dateModified: '2025-11-21T10:30:00+05:30'
        }
      },
      // {
      //   path: 'apollo',
      //   component: Apollo,
      //   data: {
      //     title: "Connect KudosHub with Apollo.com to Automate Email Validation",
      //     description: 'Automate real-time email validation inside Apollo.com with KudosHub. Score emails, eliminate bounces, and improve deliverability to maintain lead quality.',
      //     keywords: '',
      //     ogTitle: 'Connect KudosHub with Clay.com to Automate Email Validation',
      //     ogDesc: 'Automate real-time email validation inside Clay.com with KudosHub. Score emails, eliminate bounces, and improve deliverability to maintain lead quality.',
      //     ogImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     ogUrl: 'https://www.kudoshub.com/integrations/clay',
      //     twitterTitle: 'Connect KudosHub with Clay.com to Automate Email Validation',
      //     twitterDesc: 'Automate real-time email validation inside Clay.com with KudosHub. Score emails, eliminate bounces, and improve deliverability to maintain lead quality.',
      //     twitterImage: 'https://www.kudoshub.com/theme/images/og-images/logo.webp',
      //     dateModified: '2025-11-21T10:30:00+05:30'
      //   }
      // }
    ]
  }
];
